import {SupportCase as SupportCaseModel} from '../../../store/supportCaseStore';
import {BobAvatar, Heading} from '@toppy-webshop/toppy-design-system';
import SupportCaseExplanation from '../../cells/SolutionExplanation';

interface SupportCaseProps {
    supportCase: SupportCaseModel;
    cardsLayout?: boolean;
    customerName?: string;
}

const ThankYou = ({
    supportCase,
    cardsLayout,
    customerName,
}: SupportCaseProps) => {
    return (
        <div
            style={{
                width: '100%',
            }}
        >
            <div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: '1rem',
                    }}
                >
                    <BobAvatar size={'large'} />
                    <div
                        style={{
                            flexGrow: 1,
                            paddingLeft: '1rem',
                        }}
                    >
                        <Heading type={'h4'}>
                            Bedankt voor ja aanvraag{' '}
                            {customerName ? ` ${customerName}` : ''},
                            <br />
                            Hieronder zie je de vervolgstappen.
                        </Heading>
                    </div>
                </div>
                <SupportCaseExplanation supportCase={supportCase} />
            </div>
        </div>
    );
};

export default ThankYou;
